<template>
  <div class="shift-record-section">
    <div class="page-header">
      <h3>交班记录</h3>
      <a-range-picker
        v-model="dateRange"
        style="margin-right: 16px;"
      />
      <a-button type="primary" icon="search" style="margin-right: 16px;" @click="handleSearch">搜索</a-button>
      <a-button type="primary" @click="handleCreateShift">
        <a-icon type="swap" /> 交班
      </a-button>
    </div>

    <!-- 汇总卡片 -->
<!--    <a-card title="汇总数据" :bordered="false" class="shift-summary">-->
<!--      <a-row :gutter="16">-->
<!--        <a-col :span="6">-->
<!--          <a-statistic title="订单数" :value="summary.orderCount" />-->
<!--        </a-col>-->
<!--        <a-col :span="6">-->
<!--          <a-statistic title="销售金额" :value="summary.salesAmount" prefix="¥" :precision="2" />-->
<!--        </a-col>-->
<!--        <a-col :span="6">-->
<!--          <a-statistic title="会员消费" :value="summary.memberAmount" prefix="¥" :precision="2" />-->
<!--        </a-col>-->
<!--        <a-col :span="6">-->
<!--          <a-statistic title="非会员消费" :value="summary.nonMemberAmount" prefix="¥" :precision="2" />-->
<!--        </a-col>-->
<!--      </a-row>-->
<!--    </a-card>-->

    <!-- 交班记录表格 -->
    <a-table
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      @change="handleTableChange"
      :loading="loading"
      rowKey="id"
    >
      <template slot="salesAmount" slot-scope="text">
        <span style="color: #f5222d; font-weight: 600;">¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="memberAmount" slot-scope="text">
        <span style="color: #52c41a; font-weight: 600;">¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="cashAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="wechatAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="alipayAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="cardAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="checkAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="creditCardAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="balanceAmount" slot-scope="text">
        <span>¥{{ Number(text || 0).toFixed(2) }}</span>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a @click="handleViewDetail(record)">
          <a-icon type="eye" />查看详情
        </a>
      </template>
    </a-table>

    <!-- 交班弹窗 -->
    <a-modal
      v-model="shiftModalVisible"
      title="交班确认"
      @ok="handleSubmitShift"
      @cancel="shiftModalVisible = false"
      :confirmLoading="submitLoading"
      :maskClosable="false"
    >
      <a-form :form="shiftForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="接班人">
          <a-input
            v-decorator="['nextOperator', { rules: [{ required: true, message: '请输入接班人姓名' }] }]"
            placeholder="请输入接班人姓名"
          />
        </a-form-item>
<!--        <a-form-item label="本班销售金额">-->
<!--          <a-input-number-->
<!--            :value="currentSummary.salesAmount"-->
<!--            :disabled="true"-->
<!--            :precision="2"-->
<!--            style="width: 100%"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item label="本班订单数">-->
<!--          <a-input-number-->
<!--            :value="currentSummary.orderCount"-->
<!--            :disabled="true"-->
<!--            style="width: 100%"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item label="备注">
          <a-textarea
            v-decorator="['remark']"
            placeholder="请输入备注信息"
            :rows="3"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 交班详情弹窗 -->
    <a-modal
      v-model="detailModalVisible"
      title="交班记录详情"
      :footer="null"
      width="800px"
    >
      <a-descriptions bordered :column="2">
        <a-descriptions-item label="交班人">
          {{ currentDetail.createByName || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="接班人">
          {{ currentDetail.nextOperator || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="交班时间">
          {{ currentDetail.createTime || '-' }}
        </a-descriptions-item>
<!--        <a-descriptions-item label="班次">-->
<!--          {{ currentDetail.shiftType || '-' }}-->
<!--        </a-descriptions-item>-->
        <a-descriptions-item label="订单数">
          {{ currentDetail.orderCount || 0 }}
        </a-descriptions-item>
        <a-descriptions-item label="销售金额">
          ¥{{ Number(currentDetail.salesAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="会员消费">
          ¥{{ Number(currentDetail.memberAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="现金收款">
          ¥{{ Number(currentDetail.cashAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="微信收款">
          ¥{{ Number(currentDetail.wechatAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="支付宝收款">
          ¥{{ Number(currentDetail.alipayAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="银行卡收款">
          ¥{{ Number(currentDetail.cardAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="人民币支票收款">
          ¥{{ Number(currentDetail.checkAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="人民币信用卡收款">
          ¥{{ Number(currentDetail.creditCardAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="余额收款">
          ¥{{ Number(currentDetail.balanceAmount || 0).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">
          {{ currentDetail.remark || '-' }}
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
import {
  getShiftSummary,
  listShiftRecords,
  getShiftDetail,
  createShiftRecord,
  getCashierStatisticsByDateRange
} from '@/api/retail/shift'

export default {
  name: 'ShiftRecord',
  data() {
    return {
      dateRange: [],
      loading: false,
      submitLoading: false,
      shiftModalVisible: false,
      detailModalVisible: false,
      list: [],
      summary: {
        orderCount: 0,
        salesAmount: 0,
        memberAmount: 0,
        nonMemberAmount: 0
      },
      currentSummary: {
        orderCount: 0,
        salesAmount: 0
      },
      currentDetail: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '交班人', dataIndex: 'createByName', width: 100, align: 'center' },
        { title: '接班人', dataIndex: 'nextOperator', width: 100, align: 'center' },
        { title: '交班时间', dataIndex: 'createTime', width: 160, align: 'center' },
        // { title: '班次', dataIndex: 'shiftType', width: 80, align: 'center' },
        { title: '订单数', dataIndex: 'orderCount', width: 80, align: 'center' },
        { title: '销售金额', dataIndex: 'salesAmount', width: 100, align: 'center', scopedSlots: { customRender: 'salesAmount' } },
        { title: '会员消费', dataIndex: 'memberAmount', width: 100, align: 'center', scopedSlots: { customRender: 'memberAmount' } },
        { title: '现金收款', dataIndex: 'cashAmount', width: 100, align: 'center', scopedSlots: { customRender: 'cashAmount' } },
        { title: '微信收款', dataIndex: 'wechatAmount', width: 100, align: 'center', scopedSlots: { customRender: 'wechatAmount' } },
        { title: '支付宝收款', dataIndex: 'alipayAmount', width: 100, align: 'center', scopedSlots: { customRender: 'alipayAmount' } },
        { title: '支票收款', dataIndex: 'checkAmount', width: 100, align: 'center', scopedSlots: { customRender: 'checkAmount' } },
        { title: '信用卡收款', dataIndex: 'creditCardAmount', width: 110, align: 'center', scopedSlots: { customRender: 'creditCardAmount' } },
        { title: '操作', dataIndex: 'operation', width: 100, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  beforeCreate() {
    this.shiftForm = this.$form.createForm(this)
  },
  mounted() {
    this.initDateRange()
    this.loadSummary()
    this.loadList()
  },
  methods: {
    // 初始化日期范围（默认为今天）
    initDateRange() {
      const today = new Date()
      const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      this.dateRange = [startOfDay, endOfDay]
    },

    // 加载汇总数据
    async loadSummary() {
      try {
        const params = this.buildQueryParams()
        const response = await getShiftSummary(params)
        if (response.code === 20001 && response.data) {
          this.summary = {
            orderCount: response.data.orderCount || 0,
            salesAmount: response.data.salesAmount || 0,
            memberAmount: response.data.memberAmount || 0,
            nonMemberAmount: response.data.nonMemberAmount || 0
          }
          this.currentSummary = {
            orderCount: response.data.orderCount || 0,
            salesAmount: response.data.salesAmount || 0
          }
        } else {
          // 如果接口返回假数据或无数据，使用订单统计接口
          await this.loadSummaryFromOrders()
        }
      } catch (error) {
        console.error('加载汇总数据失败:', error)
        // 降级处理：从订单统计计算
        await this.loadSummaryFromOrders()
      }
    },

    // 从订单接口加载汇总数据
    async loadSummaryFromOrders() {
      try {
        const params = this.buildQueryParams()
        // 调用订单统计接口获取今日数据
        const response = await getCashierStatisticsByDateRange(params)
        if (response.code === 20001 && response.data) {
          this.summary = {
            orderCount: response.data.orderCount || 0,
            salesAmount: response.data.salesAmount || 0,
            memberAmount: response.data.memberAmount || 0,
            nonMemberAmount: response.data.nonMemberAmount || 0
          }
          this.currentSummary = {
            orderCount: response.data.orderCount || 0,
            salesAmount: response.data.salesAmount || 0
          }
        }
      } catch (error) {
        console.error('从订单加载汇总失败:', error)
      }
    },

    // 构建查询参数
    buildQueryParams() {
      const params = {}
      if (this.dateRange && this.dateRange.length === 2) {
        params.beginTime = this.formatDate(this.dateRange[0]) + ' 00:00:00'
        params.endTime = this.formatDate(this.dateRange[1]) + ' 23:59:59'
      }
      return params
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadSummary()
      this.loadList()
    },

    // 日期范围变化
    handleDateChange() {
    },

    // 表格变化
    handleTableChange(pagination) {
      this.pagination = { ...this.pagination, ...pagination }
      this.loadList()
    },

    // 加载交班记录列表
    async loadList() {
      try {
        this.loading = true
        const params = {
          ...this.buildQueryParams(),
          page: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        const response = await listShiftRecords(params)
        if (response.code == 20001) {
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else {
          // 如果没有真实数据，显示空列表
          this.list = []
        }
      } catch (error) {
        console.error('加载交班记录失败:', error)
        this.list = []
      } finally {
        this.loading = false
      }
    },

    // 创建交班记录
    handleCreateShift() {
      this.shiftForm.resetFields()
      this.shiftModalVisible = true
    },

    // 提交交班
    handleSubmitShift() {
      this.shiftForm.validateFields(async (err, values) => {
        if (err) return

        try {
          this.submitLoading = true
          const data = {
            nextOperator: values.nextOperator,
            remark: values.remark,
            orderCount: this.currentSummary.orderCount,
            salesAmount: this.currentSummary.salesAmount,
            memberAmount: this.summary.memberAmount,
            cashAmount: 0,
            wechatAmount: 0,
            alipayAmount: 0,
            cardAmount: 0,
            balanceAmount: 0,
            checkAmount: 0,
            creditCardAmount: 0
          }
          const response = await createShiftRecord(data)
          if (response.code == 20001) {
            this.$message.success('交班成功')
            this.shiftModalVisible = false
            this.loadList()
            this.loadSummary()
          } else {
            this.$message.error(response.msg || '交班失败')
          }
        } catch (error) {
          this.$message.error('交班失败')
        } finally {
          this.submitLoading = false
        }
      })
    },

    // 查看详情
    async handleViewDetail(record) {
      try {
        const response = await getShiftDetail(record.id)
        if (response.code === 20001 && response.data) {
          this.currentDetail = response.data
          this.detailModalVisible = true
        } else {
          // 如果没有详情接口，直接显示当前记录数据
          this.currentDetail = { ...record }
          this.detailModalVisible = true
        }
      } catch (error) {
        this.currentDetail = { ...record }
        this.detailModalVisible = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.shift-record-section {
  padding: 0;
  height: 100%;

  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;

    h3 {
      margin: 0 16px 0 0;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .shift-summary {
    margin-bottom: 16px;

    /deep/ .ant-statistic-title {
      font-size: 13px;
      color: #8c8c8c;
    }

    /deep/ .ant-statistic-content {
      font-size: 22px;
      font-weight: 600;
    }
  }
}
</style>
